import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from '../actions';

export interface BulkCancelStateProps {
    loading: boolean;
    hasSubmitted: boolean;
    numberOfCancelledInvoices: number;
}
export class BulkCancelState extends Record<BulkCancelStateProps>({
    loading: false,
    hasSubmitted: false,
    numberOfCancelledInvoices: 0,
}) {}

export default makeReducer<BulkCancelState>(
    [
        match(Actions.bulkCancelInvoices, state =>
            state.merge({
                loading: true,
                hasSubmitted: true,
            }),
        ),
        match(Actions.didCancelInvoice, state => {
            return state.merge({
                numberOfCancelledInvoices: state.numberOfCancelledInvoices + 1,
            });
        }),
        match(Actions.bulkCancelInvoicesSuccess, state => {
            return state.merge({
                loading: false,
            });
        }),
        match(Actions.bulkCancelInvoicesFailed, state => {
            return state.merge({
                loading: false,
            });
        }),
        match(Actions.resetCancelInvoice, () => new BulkCancelState()),
    ],
    new BulkCancelState(),
);
